import type { FC } from "react"
import type { ButtonProps } from "@chakra-ui/react"
import { Button, Link, Icon } from "@chakra-ui/react"

import InformationIcon from "ui/components/icons/InformationIcon"
import ExternalLink from "ui/components/icons/ExternalLink"

type ProposalLearnMoreAboutButtonProps = {
  label: string
  url: string
}
const ProposalLearnMoreAboutButton: FC<
  ProposalLearnMoreAboutButtonProps & ButtonProps
> = ({ label, url, ...buttonProps }) => {
  return (
    <Link isExternal className="no-underline" href={url}>
      <Button
        leftIcon={<Icon as={InformationIcon} color="gray.800" />}
        rightIcon={<Icon as={ExternalLink} />}
        size="sm"
        variant="tertiary"
        width="100%"
        {...buttonProps}
      >
        {label}
      </Button>
    </Link>
  )
}

export default ProposalLearnMoreAboutButton
